import React, { useEffect, useRef, useState } from 'react'
import { batch, useDispatch } from 'react-redux'

import { GEOLOCATION_STATUS, updateGeolocation, useGeolocation } from '../slices/geolocation'
import { setSettings, useSettings } from '../slices/settings'
import { addMessage } from '../slices/ui'

import { roundNumber } from '../utils'

import {
  ENABLE_GEOLOCATION,
  POSITION_UNAVAILABLE,
  POSITION_TIMEOUT
} from '../trans'

// come atticare https://docs.buddypunch.com/en/articles/919258-how-to-enable-location-services-for-chrome-safari-edge-and-android-ios-devices-gps-setting

const GEOLOCATION_ERROR = {
  1: ENABLE_GEOLOCATION, 
  2: POSITION_UNAVAILABLE,
  3: POSITION_TIMEOUT 
}
const GeolocationManager = (props) => {

  const dispatch = useDispatch()
  const { geolocation } = useSettings()
  const { highAccuracy } = useGeolocation()
  const [state, setState] = useState({
      status: GEOLOCATION_STATUS.WAITING,
      error: null,
  })

  useEffect(()=>{

    if (!geolocation) {
      setState({
        status: GEOLOCATION_STATUS.IDLE,
        lnglat: null,
        error: null,
      })
      return
    } else {
      setState({
        status: GEOLOCATION_STATUS.WAITING,
        lnglat: null,
        error: null,
      })
    }

    let retry = 0
    let watchId, watchPosition, clearWatch

    const options = {
      enableHighAccuracy: true,
      timeout: 20000,
      maximumAge: 0
    }

    watchPosition = navigator.geolocation.watchPosition.bind(navigator.geolocation)
    clearWatch = navigator.geolocation.clearWatch.bind(navigator.geolocation)

    const onPosition = (position) => {
      retry = 0
      if (position.coords && (position.coords.latitude && position.coords.longitude) && (!position.coords.accuracy || position.coords.accuracy < 300)){
        setState({
          status: GEOLOCATION_STATUS.FIXED,
          highAccuracy: highAccuracy,
          error: null,
          lnglat: [position.coords.longitude, position.coords.latitude].map(x => roundNumber(x, 4)),
          heading: highAccuracy ? position.coords.heading : null,
          accuracy: roundNumber(position.accuracy, -1)
        })
      }     
    }

    const onError = (error) => {
      if (error.code != 1 && retry <= 10){
        retry += 1
        watchId = watchPosition(onPosition, onError, options)
        return
      }
      setState({
        status: GEOLOCATION_STATUS.ERROR, 
        highAccuracy: highAccuracy,
        error: error.code,
        lnglat: null,
        heading: null,
        accuracy: null
      })
      clearWatch(watchId)
    }

    watchId  = watchPosition(onPosition, onError, options)

    return () => watchId && clearWatch(watchId)

  }, [geolocation, highAccuracy])

  useEffect(()=>{
    if (!state) return
    batch(()=>{
      dispatch(updateGeolocation(state))
      if (state.error) {
        const message = GEOLOCATION_ERROR[state.error]
        dispatch(addMessage({
          message: message,
          status: 'error',
          timeout: 4000
        }))
        if (state.error == 1) {
          dispatch(setSettings({geolocation: false}))
        }
      } 
    })
  }, [state, dispatch])  

  return null
}

export default GeolocationManager
